import type {GetHotelByIDClientID} from '@/api/hotelContentApi/client';
import type {Portal} from '@/types';

import {createHotelDetailsQueryOptions} from '@/api/hoteldetails';
import * as hotelContentQueries from '@/modules/common/queries/hotelContent';
import {fromGiataToRaw} from '@/modules/common/utils/hotelIdFormat';

const clientIdMapping: Record<Portal, GetHotelByIDClientID> = {
  'aidu-de': 'AIDU.de',
  'aidu-at': 'AIDU.at',
  'aidu-ch': 'AIDU.ch',
  'invia-cz': 'invia.cz',
  'invia-sk': 'invia.sk',
  'invia-hu': 'invia.hu',
  'travelplanet-pl': 'travelplanet.pl',
  'reisegeier-at': 'reisegeier.at',
  'reisegeier-ch': 'reisegeier.ch',
  'reisegeier-de': 'reisegeier.de',
  'reisen-de': 'AIDU.de',
  'reisen-fluege-de': 'AIDU.de',
};

export const getHotelDetailsFetchMethod = ({
  isHotelContentApiFeatureOn,
}: {
  isHotelContentApiFeatureOn: boolean;
}) =>
  isHotelContentApiFeatureOn
    ? (hotelId: string) =>
        hotelContentQueries.singleHotel(fromGiataToRaw(hotelId), {
          clientID: clientIdMapping[import.meta.env.VITE_PORTAL],
        })
    : createHotelDetailsQueryOptions;
